import './styles/main.css';

import React from 'react';
import ReactDOM from 'react-dom/client';

import { startMonitoring } from '~/modules/monitoring/startMonitoring';

import { App } from './App.tsx';

startMonitoring();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
